// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  Permission State
// -------------------------------
export interface PermissionState extends EntityState<any> {
  common?: any;
}

// -------------------------------
//  Permission Adapter
// -------------------------------
export const businessAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Permission Initial State
// -------------------------------
export const initialState: PermissionState = businessAdapter.getInitialState(
  {
    common: null,

  },
);
